export default function getToltReferral() {
  if (typeof window === 'undefined') return;

  if (window.tolt_referral) {
    return window.tolt_referral;
  }

  return;
}
